import { defineListQuery } from '@chukua/common';

/**
 * The picker's own query: the page, search and sort the URL keeps. The window is the page's, not the URL's, and the page size is the
 * company's setting (the server's answer), so neither is part of it.
 */
export const suggestionPickerQuerySchema = defineListQuery({ sortFields: ['rank'], defaultSort: { sort: 'rank', order: 'asc' } });
export type SuggestionPickerQuery = ReturnType<typeof suggestionPickerQuerySchema.parse>;
